<script lang="ts">
  import { onMount, createEventDispatcher } from 'svelte';
  import { env } from '$env/dynamic/public';
  import { logger } from '$lib/logger';

  export let additionalClasses: string | null = null;
  let recaptchaId: number | null = null;

  const dispatch = createEventDispatcher();

  function onRecaptchaSuccess(recaptchaToken: string) {
    dispatch('tokenGenerated', { token: recaptchaToken });
  }

  export function reset() {
    if (recaptchaId !== null && (window as any).grecaptcha) {
      (window as any).grecaptcha.reset(recaptchaId);
    }
  }

  function onLoadCallback() {
    if ((window as any).grecaptcha) {
      recaptchaId = (window as any).grecaptcha.render('recaptcha', {
        sitekey: env.PUBLIC_RECAPTCHA_SITE_KEY,
        callback: onRecaptchaSuccess,
        theme: 'dark'
      });
    } else {
      logger.error('reCAPTCHA failed to load');
    }
  }

  onMount(() => {
    (window as any).onLoadCallback = onLoadCallback;

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=onLoadCallback&hl=en`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  });
</script>

<div id="recaptcha" class="g-recaptcha {additionalClasses}"></div>

<style>
  /* Patch to address a style issue in the Google library */
  .g-recaptcha :global(iframe) {
    border-radius: 5px;
    width: 300px;
    height: 75px;
  }
</style>
